module.exports = __webpack_public_path__ + "img/retangule_top_right.b151d27a.svg";